// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 260px;
  height: 100vh;
  background: linear-gradient(to bottom, #0f172a, #1e293b);
  color: white;
  position: fixed;
  left: 0;
  top: 100;
  transition: all 0.3s ease;
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow-y: auto;
}

.sidebar.collapsed {
  width: 85px;
}

/* Header */

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 15px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.brand-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-icon {
  width: 50px;
  height: 50px;
  background: #0d6efd;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  box-shadow: 0 5px 12px rgba(13, 110, 253, 0.4);
}

.brand-title {
  margin: 0;
  font-weight: 700;
}

.brand-subtitle {
  color: #cbd5e1;
}

/* Toggle Button */

.toggle-btn {
  border: none;
  background: white;
  color: #0f172a;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  transition: 0.3s;
}

.toggle-btn:hover {
  background: #0d6efd;
  color: white;
}

/* Menu */

.sidebar-menu {
  padding: 20px 10px;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 14px;
  color: #e2e8f0;
  text-decoration: none;
  padding: 14px 16px;
  margin-bottom: 8px;
  border-radius: 14px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.sidebar-link:hover {
  background: rgba(255,255,255,0.08);
  color: white;
  transform: translateX(5px);
}

.active-menu {
  background: linear-gradient(to right, #0d6efd, #3b82f6);
  color: white !important;
  box-shadow: 0 6px 15px rgba(13, 110, 253, 0.35);
}

.menu-icon {
  font-size: 18px;
  min-width: 20px;
}

/* Footer */

.sidebar-footer {
  position: absolute;
  bottom: 15px;
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: #cbd5e1;
}

/* Scrollbar */

.sidebar::-webkit-scrollbar {
  width: 5px;
}

.sidebar::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.15);
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,wDAAwD;EACxD,YAAY;EACZ,eAAe;EACf,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;;AAElB;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,SAAS;;AAET;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,uDAAuD;EACvD,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,cAAc;;AAEd;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB","sourcesContent":[".sidebar {\r\n  width: 260px;\r\n  height: 100vh;\r\n  background: linear-gradient(to bottom, #0f172a, #1e293b);\r\n  color: white;\r\n  position: fixed;\r\n  left: 0;\r\n  top: 100;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  overflow-y: auto;\r\n}\r\n\r\n.sidebar.collapsed {\r\n  width: 85px;\r\n}\r\n\r\n/* Header */\r\n\r\n.sidebar-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 20px 15px;\r\n  border-bottom: 1px solid rgba(255,255,255,0.1);\r\n}\r\n\r\n.brand-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.brand-icon {\r\n  width: 50px;\r\n  height: 50px;\r\n  background: #0d6efd;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 22px;\r\n  box-shadow: 0 5px 12px rgba(13, 110, 253, 0.4);\r\n}\r\n\r\n.brand-title {\r\n  margin: 0;\r\n  font-weight: 700;\r\n}\r\n\r\n.brand-subtitle {\r\n  color: #cbd5e1;\r\n}\r\n\r\n/* Toggle Button */\r\n\r\n.toggle-btn {\r\n  border: none;\r\n  background: white;\r\n  color: #0f172a;\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 10px;\r\n  transition: 0.3s;\r\n}\r\n\r\n.toggle-btn:hover {\r\n  background: #0d6efd;\r\n  color: white;\r\n}\r\n\r\n/* Menu */\r\n\r\n.sidebar-menu {\r\n  padding: 20px 10px;\r\n}\r\n\r\n.sidebar-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  color: #e2e8f0;\r\n  text-decoration: none;\r\n  padding: 14px 16px;\r\n  margin-bottom: 8px;\r\n  border-radius: 14px;\r\n  transition: all 0.3s ease;\r\n  font-weight: 500;\r\n}\r\n\r\n.sidebar-link:hover {\r\n  background: rgba(255,255,255,0.08);\r\n  color: white;\r\n  transform: translateX(5px);\r\n}\r\n\r\n.active-menu {\r\n  background: linear-gradient(to right, #0d6efd, #3b82f6);\r\n  color: white !important;\r\n  box-shadow: 0 6px 15px rgba(13, 110, 253, 0.35);\r\n}\r\n\r\n.menu-icon {\r\n  font-size: 18px;\r\n  min-width: 20px;\r\n}\r\n\r\n/* Footer */\r\n\r\n.sidebar-footer {\r\n  position: absolute;\r\n  bottom: 15px;\r\n  width: 100%;\r\n  text-align: center;\r\n  font-size: 13px;\r\n  color: #cbd5e1;\r\n}\r\n\r\n/* Scrollbar */\r\n\r\n.sidebar::-webkit-scrollbar {\r\n  width: 5px;\r\n}\r\n\r\n.sidebar::-webkit-scrollbar-thumb {\r\n  background: rgba(255,255,255,0.15);\r\n  border-radius: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
